var _desc, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbstractAvatar17SquareStreamlineAbstract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 513 513",
    height: 100,
    width: 100,
    strokeWidth: 1,
    id: "Abstract-Avatar-17-Square--Streamline-Abstract.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Abstract Avatar 17 Square Streamline Emoji: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    id: "Abstract-Avatar-17-Square--Streamline-Abstract.svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M.694.871h512v512h-512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa8af",
    d: "M300.994 148.808c0-24.421-19.797-44.218-44.218-44.218-24.42 0-44.217 19.797-44.217 44.218v48.474l-23.95-42.145c-12.065-21.232-39.058-28.663-60.29-16.597-21.232 12.065-28.6631 39.058-16.598 60.29l27.253 47.958-47.9574-27.253c-21.232-12.066-48.2249-4.635-60.2904 16.597s-4.6346 48.225 16.5974 60.291l42.1444 23.949H40.9941c-24.4208 0-44.21773 19.797-44.21773 44.218 0 24.421 19.79693 44.218 44.21773 44.218h48.4738l-42.1443 23.949c-21.232 12.065-28.6629 39.058-16.5974 60.29s39.0585 28.663 60.2905 16.598l47.9583-27.253-27.253 47.958c-12.066 21.232-4.635 48.224 16.597 60.29 21.232 12.065 48.225 4.635 60.29-16.597l23.95-42.145v48.474c0 24.421 19.797 44.218 44.217 44.218 24.421 0 44.218-19.797 44.218-44.218v-48.474l23.949 42.145c12.066 21.232 39.059 28.662 60.291 16.597 21.232-12.066 28.663-39.058 16.597-60.29l-27.253-47.958 47.958 27.253c21.232 12.065 48.225 4.634 60.291-16.598 12.065-21.232 4.634-48.225-16.598-60.29l-42.144-23.949h48.474c24.42 0 44.217-19.797 44.217-44.218 0-24.421-19.797-44.218-44.217-44.218h-48.474l42.144-23.949c21.232-12.066 28.663-39.059 16.598-60.291-12.066-21.232-39.059-28.663-60.291-16.597l-47.958 27.253 27.253-47.958c12.066-21.232 4.635-48.225-16.597-60.29-21.232-12.066-48.225-4.635-60.29 16.597l-23.95 42.145v-48.474Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 16,
    d: "M292.776 376.59c0 9.941-8.06 18-18.002 18-9.799 0-17.77-7.828-17.998-17.571"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 16,
    d: "M256.776 376.59c0 9.941-8.06 18-18.002 18-9.799 0-17.77-7.828-17.998-17.571"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M292.776 316.59a12 12 0 1 0 24 0 12 12 0 1 0-24 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M196.776 316.59a12 12 0 1 0 24 0 12 12 0 1 0-24 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M0 0h512v512H0z",
    transform: "translate(.276 .59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractAvatar17SquareStreamlineAbstract);
export default __webpack_public_path__ + "static/media/Abstract-Avatar-17-Square--Streamline-Abstract.a013876eb4ae5e4139ec4f8558b9727f.svg";
export { ForwardRef as ReactComponent };